/* this file is transformed by vux-loader */
/* eslint-disable */
import _asyncToGenerator from "G:/SVN/\u5B9A\u5236\u9879\u76EE/\u534E\u7535\u5F00\u5173/7_\u6E90\u4EE3\u7801/front/smy-vux-cli3-h5-huadian/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ViewBox from "vux/src/components/view-box/index.vue";
import Timeline from '@/components/Timeline';
import TimelineItem from '@/components/Timeline/TimelineItem';
import { getHdOrderServiceProgress } from '@/api';
export default {
  name: 'ServiceSchedule',
  components: {
    ViewBox: ViewBox,
    Timeline: Timeline,
    TimelineItem: TimelineItem
  },
  props: {
    oid: [String, Number],
    orderInfo: Object
  },
  computed: {
    progressList: function progressList() {
      return this.signInfos.concat(this.projectProductLogs);
    }
  },
  data: function data() {
    return {
      signInfos: [],
      projectProductLogs: []
    };
  },
  activated: function activated() {
    this.reload();
  },
  methods: {
    reload: function reload() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getHdOrderServiceProgress({
                  id: _this.oid
                });

              case 2:
                res = _context.sent;
                console.log(11, res.data.data);

                if (res.data.success) {
                  _this.signInfos = (res.data.data.signInfos || []).map(function (v) {
                    v.type = 1;
                    return v;
                  });
                  _this.projectProductLogs = (res.data.data.projectProductLogs || []).map(function (v) {
                    v.type = 2;
                    return v;
                  });
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};